<template>
  <PageSecondary>
    <template #title>Коучинг</template>

    <h4>Знакомство</h4>
    <p>
      Видеозвонок 10 минут бесплатно, чтобы почувствовать, хотим ли работать вместе.
    </p>

    <h4>Набор добровольцев</h4>
    <p>
      Смелые могут пойти добровольцем на консультацию по моим экспериментальным методикам.
      Стоит 1000₽ за сеанс, это не классический коучинг! Чтобы записаться в очередь - напиши в
      <TextMe/>
    </p>

    <ImgBlock asset="handdrawn/aaa.jpg"/>

    <h4>Стоимость и длительность</h4>
    <ul>
      <li>Время консультации выбирается между 45 и 120 минутами.</li>
      <li>Стоимость консультации - 4000₽ за 90 минут.</li>
      <li>В зависимости от вашего положения и дохода можно обсудить несколько сеансов за меньшую стоимость.</li>
    </ul>

    <h4>Стиль работы</h4>
    <ul>
      <li>Я стремлюсь к тому, чтобы консультация завершилась решением запроса.</li>
      <li>Решение запроса на консультации - результат общей работы, вас и меня. Вы - гребёте, я создаю условия, чтобы вы
        гребли в сторону решения.
      </li>
<!--      <li>Меня клонит в сон от консультаций в размеренном темпе. Я выбираю решить 10 запросов за 10 сеансов,-->
<!--        чем растягивать на 10 один запрос.-->
<!--      </li>-->
<!--      <li>У меня есть инструменты, чтобы любой запрос разрешать не за 3 года, а за 3 созвона.</li>-->
      <li>Я против второсортной работы, поэтому иногда отменяю консультации, если оказался не в максимальной ресурсности.
      </li>
    </ul>

    <ImgBlock asset="handdrawn/wish-or-will.jpg"/>

    <h4>Чтобы была польза</h4>
    <ul>
      <li>У вас обязательно должен быть примерный запрос с которым вы хотите работать.</li>
      <li>Запрос «Найти запрос» - прекрасный.</li>
      <li>За время консультации запрос может изменяться по вашему желаю.</li>
    </ul>

    <h4>Чтобы было эффективно</h4>
    <ul>
      <li>Вам нужно быть в тишине и одиночестве на время консультации.</li>
      <li>Хороший звук и связь.</li>
    </ul>

    <ImgBlock asset="handdrawn/life-loving.jpg"/>
    <p>Скорее всего жизнелюбие движет тобой, когда ты в поиске путей роста.</p>

    <h4>Как записаться?</h4>
    <p>Напиши мне в <TextMe/> "Привет! Я Мефодий, хочу обсудить коучинг".</p>

    <h4>Правила отмены и пропуска</h4>
    <ul>
      <li>Если консультация отменена меньше, чем за 5 часов - необходимо оплатить 25% стоимости консультации.
      <li>При отмене консультации за 30 минут до начала или пропуске - оплачивается 50% консультации.</li>
      <li>Если я отменил консультацию меньше чем за 5 часов - следующая консультация со скидкой 25%.</li>
    </ul>

    <ImgBlock asset="handdrawn/pink-clouds-calling.jpg"/>

  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
import TextMe from "@/components/components/TextMe";
import ImgBlock from "@/components/blocks/ImgBlock";

export default {
  name: "WannaStartup",
  components: {ImgBlock, TextMe, PageSecondary}
}
</script>

<style scoped>
p {
  display: block;
  margin: 24px 0 0 0;
}
</style>
